import { Component, Input } from '@angular/core';

import { MijnNavigatieService } from '@ap/mijn-navigatie';

import { MijnTemplateNavigation } from '../../mijn-template.navigation';

import { Breadcrumb } from './breadcrumb.model';

/**
 * @module BreadcrumbModule
 * @ngdoc component
 * @name BreadcrumbComponent
 */
@Component({
    selector: 'mijn-overzicht-template-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent {
    @Input()
    public breadcrumb: Breadcrumb;

    public constructor(
        private readonly mijnNavigatieService: MijnNavigatieService,
        private readonly mijnTemplateNavigation: MijnTemplateNavigation
    ) {}

    public navigateBack(): void {
        const routeKey = this.mijnNavigatieService.getRouteKeyForPath(this.breadcrumb.path);
        if (this.breadcrumb.internal) {
            this.mijnTemplateNavigation.internal(this.breadcrumb.path);
        } else if (this.breadcrumb.dynamic) {
            this.mijnTemplateNavigation.dynamicBack();
        } else if (!!routeKey) {
            this.mijnNavigatieService.navigate(routeKey);
        } else {
            this.mijnNavigatieService.navigateByUrl(this.breadcrumb.path);
        }
    }
}
